const organisation = {
  email_title_required: 'Le titre du courriel est requis lorsque le message est rempli',
  email_message_required: 'Le message du courriel est requis lorsque le titre est rempli',
};

export default organisation;
